import type {Properties} from 'posthog-js'

type PostHogClient = typeof import('posthog-js').posthog

let posthog: PostHogClient | null = null
let loadingPostHog: Promise<void> | null = null
let pendingIdentity: {id: string; properties: Properties} | null = null
const pendingExceptions: Array<{error: unknown; properties?: Properties}> = []
const errorTrackingEnabled = import.meta.env.VITE_APP_ENV === 'production'

export function initializePostHog(): void {
  if (posthog !== null || loadingPostHog !== null || typeof window === 'undefined') return

  loadingPostHog = import('posthog-js').then(({posthog: client}) => {
    client.init('phc_OeDI7MK0P417Vr93Umk0Y0malFhVewXSrtz3ad6A1ZI', {
      api_host: 'https://water.batuice.com',
      capture_exceptions: errorTrackingEnabled,
    })
    posthog = client

    if (pendingIdentity !== null) {
      try {
        client.identify(pendingIdentity.id, pendingIdentity.properties)
      } catch (error) {
        console.error('Unable to identify the PostHog user', error)
      }
      pendingIdentity = null
    }

    for (const exception of pendingExceptions.splice(0)) {
      try {
        client.captureException(exception.error, exception.properties)
      } catch (error) {
        console.error('Unable to capture a PostHog exception', error)
      }
    }
  }).catch((error: unknown) => {
    loadingPostHog = null
    console.error('Unable to initialize PostHog', error)
  })
}

export function capturePostHogException(error: unknown, properties?: Properties): void {
  if (!errorTrackingEnabled) return

  if (posthog !== null) {
    try {
      posthog.captureException(error, properties)
    } catch (captureError) {
      console.error('Unable to capture a PostHog exception', captureError)
    }
    return
  }

  if (pendingExceptions.length < 10) pendingExceptions.push({error, properties})
  initializePostHog()
}

export function identifyPostHog(id: string, properties: Properties): void {
  if (posthog !== null) {
    try {
      posthog.identify(id, properties)
    } catch (error) {
      console.error('Unable to identify the PostHog user', error)
    }
    return
  }

  pendingIdentity = {id, properties}
  initializePostHog()
}
